import { useIntl } from "react-intl";
import { WmActionMenu, WmMenuitem } from "@watermarkinsights/ripple-react";
import { buildSvgIconHref } from "../ai-chat-message-utils";

interface MessageExportMenuProps {
  onExportPdf: () => void;
  onExportText: () => void;
  disabled?: boolean;
}

export const MessageExportMenu = ({
  onExportPdf,
  onExportText,
  disabled = false,
}: MessageExportMenuProps) => {
  const intl = useIntl();

  return (
    <span className="tcw-export-menu">
      <WmActionMenu
        action-menu-type="icon"
        icon-size="1.25rem"
        className="tcw-export-menu__trigger"
        max-width="15.75rem"
        tooltip={intl.formatMessage({ id: "app.toolboxChat.action.exportMessage" })}
        disabled={disabled}
      >
        <WmMenuitem
          icon={buildSvgIconHref("export-pdf")}
          description={intl.formatMessage({
            id: "app.toolboxChat.action.exportMessageAsPdfDescription",
          })}
          onClick={onExportPdf}
        >
          {intl.formatMessage({ id: "app.toolboxChat.action.exportMessageAsPdf" })}
        </WmMenuitem>
        <WmMenuitem
          icon={buildSvgIconHref("export-text")}
          description={intl.formatMessage({
            id: "app.toolboxChat.action.exportMessageAsTextDescription",
          })}
          onClick={onExportText}
        >
          {intl.formatMessage({ id: "app.toolboxChat.action.exportMessageAsText" })}
        </WmMenuitem>
      </WmActionMenu>
      <svg className="tcw-export-menu__icon" aria-hidden="true" focusable="false">
        <use href={buildSvgIconHref("export-trigger")} />
      </svg>
    </span>
  );
};
